<template>
  <v-container>
    <TaxAdditionsCriteria :baseCrudKey="baseCrudKey" />
    <CRUDList
      ref="crudList"
      :canAdd="canAddToSharedList"
      :canEdit="true"
      :canSave="false"
      :canCancel="false"
      :showSelect="false"
      :enableFixedHeaders="true"
      :displayTopPagination="false"
      :headers="headers"
      :baseCrudKey="baseCrudKey"
      :defaultSortBy="defaultSortBy"
      :dialogHeaderName="dialogHeaderName"
      :tableTitle="dialogHeaderName"
      :canDeleteInDialog="true"
      dialogDynamicWidth="30vw"
      tableWrapperDynamicClassname='elevation-3 ma-3 pa-1 taxroll-table-wrapper'
      tableDynamicClassname='taxroll-custom-table'
      tableDynamicHeight='350'
      @deleteItem="deleteFromDiaglog"
      @loadCRUDList="handleLoadTaxAdditionList"
      :loadingData="gridLoading.flag"
      :loadingText="gridLoading.text"
      :dataMapper="additionsDataMapper"
   >
    <template v-slot:[`editedItem`]="{}">
      <taxAdditionsEditDialog />
    </template>
    <template v-slot:[`additionalActionsAfterSave`]="{}">
      <v-btn class="input-text-size" text
        color="blue darken-1" @click="upsertRecords()">
        Save
      </v-btn>
      <v-btn class="input-text-size" text
        color="blue darken-1" @click="closeDialog">
        Cancel
      </v-btn>
    </template>
   </CRUDList>
  </v-container>
</template>

<script>
import {
  mapMutations, mapActions, mapGetters,
} from 'vuex';
import TaxAdditionsCriteria from './taxAdditionsCriteria.vue';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import { TaxAdditionsHeaders } from '../Utils/taxHeaders.utils';
import taxAdditionsEditDialog from './taxAdditionsEditDialog.vue';
import '../../../assets/style.css';
import { defaultGridLoading, manageGridLoading } from '../../../util/shared/vue-global';
import SharedListAccessControlMixin from '../SharedListAccessControl.mixin';

export default {
  name: 'taxAdditionsList',
  mixins: [SharedListAccessControlMixin],
  components: {
    TaxAdditionsCriteria,
    CRUDList,
    taxAdditionsEditDialog,
  },
  data() {
    return {
      selectedRows: [],
      baseCrudKey: 'taxAdditionsTable',
      selectedRow: null,
      headers: TaxAdditionsHeaders,
      dialogHeaderName: 'Additions',
      gridLoading: defaultGridLoading(),
    };
  },

  computed: {
    ...mapGetters('base/crud', ['criteria', 'item']),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'additionCode',
          direction: 'asc',
        },
      ];
    },
  },
  methods: {
    manageGridLoading,
    ...mapMutations('base/crud', ['setCriteria', 'setIsVisible', 'setItem']),
    ...mapActions('shared/TaxAdditions', [
      'loadTaxAdditionsRecords',
      'upsertTaxAdditions',
      'deleteTaxAddition',
    ]),
    additionsDataMapper(items) {
      return (items || []).map((r) => ({
        ...r,
        section: r.section != null ? r.section : '',
        range: r.range != null ? r.range : '',
        quarter: r.quarter != null ? r.quarter : null,
      }));
    },
    async upsertRecords() {
      const isValidForm = this.$refs.crudList.$refs.crudDialog.validateForm();
      if (isValidForm) {
        const { baseCrudKey } = this;
        const updatedItem = this.item(this.baseCrudKey);
        const returnRes = await this.upsertTaxAdditions({ item: updatedItem, baseCrudKey });
        if (returnRes.statusCode === 200) {
          this.closeDialog();
          this.handleLoadTaxAdditionList();
        }
      }
    },
    deleteFromDiaglog(item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        const { baseCrudKey } = this;
        this.deleteTaxAddition({ item, baseCrudKey });
      }
    },
    handleLoadTaxAdditionList() {
      const { baseCrudKey } = this;
      const criteria = { ...this.criteriaState };
      manageGridLoading(this, true, 'Searching...');
      this.loadTaxAdditionsRecords({ baseCrudKey, criteria }).finally(() => {
        manageGridLoading(this, false);
      });
    },
    closeDialog() {
      this.setIsVisible([this.baseCrudKey, false]);
      this.setItem([this.baseCrudKey, {}]);
    },
  },
};
</script>
<style>
.flex {
display: flex;
justify-content: center;
}
</style>
